import Vue from 'vue'
import http from '@/http'
import { filter } from 'lodash'
import createCrudModule from 'vuex-crud'

let parseError = res => res
let parseSingle = res => res

export default createCrudModule({
  client: http,
  resource: 'complexes/sections',
  urlRoot: 'complexes/sections',

  state: {
    complexes: {},
    objects: {}
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.list,
      complex: response.data.complex,
      object: response.data.object
    })
  },

  onFetchListSuccess(state, { complex, object }) {
    Vue.set(state.objects, [object.id], object)
    Vue.set(state.complexes, [complex.id], complex)
  },

  getters: {
    complexById: state => id => {
      return state.complexes[+id] || {}
    },

    objectById: state => id => {
      return state.objects[+id] || {}
    },

    objectSections: state => id => {
      return filter(state.entities, {
        object_id: +id
      })
    }
  },

  actions: {
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`complexes/sections/${id}`, data, config)
        .then(res => {
          let parsedResponse = parseSingle(res)
          commit('updateSuccess', parsedResponse)
          return parsedResponse
        })
        .catch(err => {
          let parsedError = parseError(err)
          commit('updateError', parsedError)
          return Promise.reject(parsedError)
        })
    }
  }
})
